export enum SenderConectivityStatus {
    PendingAddition = 1,
    Added = 2,
    PendingDeletion = 3,
    Deleted = 4,
    Canceled = 5,
    Skipped = 6,
}